module.exports = __webpack_public_path__ + "img/mitbach_no.8590e95d.png";